import {mdiCheck, mdiClose} from '@mdi/js'
import Icon from '@mdi/react'
import {IconButton, Tooltip} from '@mui/material'

// Legacy-stack twin of pages-new/secondaryAssumptions/AssumptionTakenChoiceNew. The "Hai assunto
// la terapia?" answer as two large round buttons — same visual language as the list's
// QuickAnswerButtons (round, outlined, icon-only), just bigger: this is the one full-page decision
// a reminder link exists for. The selected one fills solid (white icon on the semantic color, plus
// the light outline ring) so reopening an already-answered reminder makes the previous choice
// obvious at a glance, not just a faint ring around an otherwise identical pair of outlined buttons.

type AssumptionTakenChoiceProps = {
  value: 'yes' | 'no' | null
  onChange: (value: 'yes' | 'no') => void
  disabled?: boolean
}

const SIZE = 56

const AssumptionTakenChoice: React.FC<AssumptionTakenChoiceProps> = ({value, onChange, disabled}) => {
  const yesSelected = value === 'yes'
  const noSelected = value === 'no'

  return (
    <div style={{display: 'flex', gap: 24}}>
      <Tooltip title="Sì, l'ho assunta">
        <span>
          <IconButton
            aria-label="Sì, l'ho assunta"
            disabled={disabled}
            onClick={() => onChange('yes')}
            style={{
              width: SIZE,
              height: SIZE,
              color: yesSelected ? '#fff' : '#16A34A',
              backgroundColor: yesSelected ? '#16A34A' : 'transparent',
              border: '2px solid #16A34A',
              outline: yesSelected ? '3px solid #DCFCE7' : 'none',
              outlineOffset: 2
            }}
          >
            <Icon path={mdiCheck} size={1.1} />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="No, non l'ho assunta">
        <span>
          <IconButton
            aria-label="No, non l'ho assunta"
            disabled={disabled}
            onClick={() => onChange('no')}
            style={{
              width: SIZE,
              height: SIZE,
              color: noSelected ? '#fff' : '#DC2626',
              backgroundColor: noSelected ? '#DC2626' : 'transparent',
              border: '2px solid #DC2626',
              outline: noSelected ? '3px solid #FEE2E2' : 'none',
              outlineOffset: 2
            }}
          >
            <Icon path={mdiClose} size={1.1} />
          </IconButton>
        </span>
      </Tooltip>
    </div>
  )
}

export default AssumptionTakenChoice
